export function resolveEffectiveTemplateType(
  rankingEntityType: string | null,
  publicationTemplateType: string | null,
): string | null {
  if (rankingEntityType === "bar") return "bar";
  return publicationTemplateType;
}
